import React, { memo, useCallback, useEffect } from 'react';

import useStore from '@/state';
import setSizeAction from '@/state/selectors/window/set-size';

const ViewportHandlerComponent: React.FC = () => {
	const setSize = useStore(setSizeAction);

	const onResize = useCallback(() => {
		const { innerWidth: width, innerHeight: height } = window;
		setSize(width, height);
	}, [setSize]);

	useEffect(() => {
		onResize();

		globalThis.addEventListener('resize', onResize);

		return () => {
			globalThis.removeEventListener('resize', onResize);
		};
	}, [onResize]);

	return null;
};

const ViewportHandler = memo(ViewportHandlerComponent);

export default ViewportHandler;
